var React = require('react');

function TierFeaturesDivider (props) {
    return React.createElement("svg",props,[React.createElement("line",{"y1":"22.5","x2":"115","y2":"22.5","stroke":"#B79DFF","key":0}),React.createElement("circle",{"cx":"57.5","cy":"22.5","r":"22.5","fill":"currentColor","key":1}),React.createElement("rect",{"x":"65","y":"22","width":"1","height":"15","transform":"rotate(90 65 22)","fill":"#B79DFF","key":2}),React.createElement("rect",{"x":"57","y":"15","width":"1","height":"15","fill":"#B79DFF","key":3})]);
}

TierFeaturesDivider.defaultProps = {"width":"115","height":"45","viewBox":"0 0 115 45","fill":"none"};

module.exports = TierFeaturesDivider;

TierFeaturesDivider.default = TierFeaturesDivider;
